module.exports = __webpack_public_path__ + "img/block01.0bd072af.webp";